import React from 'react';

import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import DateTime from 'react-datetime';

import * as APPDATA from '@/constants/pcConstAppData';

import './DateTimePicker.less';

class DateTimePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateAndTime: new Date(),
    };
    this.handleChange = this.handleChange.bind(this);
    this.onClose = this.onClose.bind(this);
    this.applyChange = this.applyChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({
        dateAndTime: nextProps.value,
      });
    }
  }

  handleChange(e) {
    const {timeFormat} = this.props;
    const pickDateAndTime = e._d;
    this.setState({dateAndTime: pickDateAndTime}, () => {
      if (!timeFormat) this.onClose();
    });

    return true;
  }

  onClose() {
    const {onClose, id} = this.props;
    const {dateAndTime} = this.state;
    onClose(id, dateAndTime);
  }

  applyChange() {
    const {onApplyTime, id} = this.props;
    const {dateAndTime} = this.state;
    onApplyTime(id, dateAndTime);
  }

  render() {
    const {showDateTime, id, isValidDate, dateFormat, timeFormat, className} = this.props;
    const {dateAndTime} = this.state;

    return (
      <Modal
        id={id}
        show={showDateTime}
        onHide={this.onClose}
        dialogClassName="date-time-dialog"
        className={`disableTextSelect ${className}`}
      >
        <Modal.Body className="date-time-body">
          <div className="dateTime">
            <DateTime
              input={false}
              isValidDate={isValidDate}
              value={dateAndTime}
              viewMode={DateTimePicker.FieldMode.days}
              dateFormat={dateFormat}
              timeFormat={timeFormat}
              onChange={this.handleChange}
              closeOnSelect={!timeFormat}
              closeOnTab
            />
            {timeFormat && (
              <div className="row center">
                <button
                  type="button"
                  id={APPDATA.DEVICE_TIME}
                  className="applyButton "
                  onClick={this.applyChange}
                  disabled={false}
                >
                  {APPDATA.APPLY.toUpperCase()}
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
export default DateTimePicker;

DateTimePicker.FieldMode = {
  years: 'years',
  months: 'months',
  days: 'days',
  time: 'time',
};

DateTimePicker.viewMode = {
  date: DateTimePicker.FieldMode.days,
  time: DateTimePicker.FieldMode.time,
};
DateTimePicker.format = {
  date: 'YYYY-MM-DD',
  time: 'HH MM SS a',
};

DateTimePicker.propTypes = {
  value: PropTypes.bool,
  onClose: PropTypes.func,
  onApplyTime: PropTypes.func,
  showDateTime: PropTypes.bool,
  id: PropTypes.string,
  isValidDate: PropTypes.bool,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  className: PropTypes.string,
};

DateTimePicker.defaultProps = {
  value: new Date(),
  isValidDate: false,
  id: '',
  dateFormat: 'YYYY-MM-DD',
  timeFormat: 'HH:mm (hh:mm a)',
  onApplyTime() {
    return true;
  },
  onClose() {
    return true;
  },
  showDateTime: false,
  className: '',
};
